/**
 * Pulse SRE Investigation — visual theme tokens (class helpers).
 * Distinct from OpenSRE stone/forest aesthetic; aligned with Pulse primary/secondary.
 */

export const SRE_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=IBM+Plex+Mono:wght@400;500&display=swap';

/** Ensure DM Sans + IBM Plex Mono are loaded once. */
export function ensureSreFontsLoaded(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById('sre-investigation-fonts')) return;
  const link = document.createElement('link');
  link.id = 'sre-investigation-fonts';
  link.rel = 'stylesheet';
  link.href = SRE_FONTS_HREF;
  document.head.appendChild(link);
}

export const sre = {
  workbench: 'sre-wb font-[\'DM_Sans\',ui-sans-serif,system-ui,sans-serif] text-slate-900 antialiased',
  mono: 'font-[\'IBM_Plex_Mono\',ui-monospace,monospace]',
  surface: 'bg-slate-50',
  panel: 'bg-white',
  ink: 'text-slate-900',
  muted: 'text-slate-500',
  line: 'border-slate-200',
  accent: 'text-primary-600',
  accentBg: 'bg-primary-50',
  accentBorder: 'border-primary-200',
  signal: 'text-secondary-700',
  signalBg: 'bg-secondary-100',
} as const;
